<template>
  <div v-if="visibleProducts.length > 0" class="cart-suggestions">
    <h3 class="suggestions-title">¿Te tienta algo más?</h3>
    <div class="suggestions-scroll">
      <div
        v-for="p in visibleProducts"
        :key="p.id"
        class="suggestion-card"
      >
        <div class="suggestion-img-wrap" @click="openProduct(p)">
          <v-img
            v-if="!hasNoImage(p)"
            :src="imagenCard(p.detalle && p.detalle.srcImg)"
            aspect-ratio="1"
            class="suggestion-img"
            cover
          ></v-img>
          <div v-else class="suggestion-img suggestion-img--empty">
            <v-icon color="grey lighten-1">mdi-food</v-icon>
          </div>
          <button
            type="button"
            class="suggestion-add"
            :disabled="tiendaCerrada || isProductoAgotado(p)"
            aria-label="Agregar"
            @click.stop="onAdd(p)"
          >
            <v-icon small>mdi-plus</v-icon>
          </button>
        </div>
        <div class="suggestion-body" @click="openProduct(p)">
          <div class="suggestion-name">{{ p.nombre }}</div>
          <div v-if="p.detalle && p.detalle.descripcion" class="suggestion-desc">
            {{ p.detalle.descripcion }}
          </div>
          <div v-if="tieneDescuento(p)" class="suggestion-price">
            <span>${{ formatPrice(precioConDescuento(p)) }}</span>
            <del class="suggestion-price-old">${{ formatPrice(p.precio) }}</del>
          </div>
          <div v-else class="suggestion-price">${{ formatPrice(p.precio) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from '@/axios/axios-api.js'
import { mapActions, mapGetters } from 'vuex'
import { isProductoAgotado as checkProductoAgotado } from '@/helpers/productoAgotado.js'
import descuentoHelper from '@/helpers/descuentosHelper.js'
import { imagenCard } from '@/helpers/imagenTienda.js'

export default {
  name: 'CartSuggestions',
  data () {
    return {
      products: [],
      loading: false
    }
  },
  computed: {
    ...mapGetters('App', ['tiendaCerrada']),
    ...mapGetters('Carrito', ['getItems']),
    cartProductIds () {
      return new Set(
        (this.getItems || []).map(i => i.productId || i.id).filter(Boolean)
      )
    },
    seedProductId () {
      const items = this.getItems || []
      if (!items.length) return null
      const last = items[items.length - 1]
      return last.productId || last.id || null
    },
    visibleProducts () {
      return (this.products || [])
        .filter(p => p && p.id && !this.cartProductIds.has(p.id) && Number(p.precio) > 0 && !checkProductoAgotado(p))
        .slice(0, 10)
    }
  },
  watch: {
    seedProductId: {
      immediate: true,
      handler () {
        this.load()
      }
    },
    getItems: {
      deep: true,
      handler () {
        // re-filter only; reload if emptied then refilled with new seed
      }
    }
  },
  methods: {
    imagenCard,
    ...mapActions('Carrito', ['addItem']),
    formatPrice (n) {
      const num = Number(n) || 0
      return num.toLocaleString('es-AR')
    },
    precioConDescuento (p) {
      return descuentoHelper.precioConDescuento(p)
    },
    tieneDescuento (p) {
      return Number(this.precioConDescuento(p)) !== Number(p.precio)
    },
    hasNoImage (p) {
      const src = p && p.detalle && p.detalle.srcImg
      return !src || String(src).includes('noimage_Producto.png')
    },
    isProductoAgotado (p) {
      return checkProductoAgotado(p)
    },
    async load () {
      if (this.loading) return
      this.loading = true
      try {
        const code = this.$clientCode()
        const requests = [
          axios.get(`api/productos/mas-vendidos/${code}`, { params: { dias: 30, top: 12 } })
        ]
        if (this.seedProductId) {
          requests.push(
            axios.get(`api/producto/${this.seedProductId}/combinados-con`, {
              params: { top: 6, dias: 90 }
            })
          )
        }
        const results = await Promise.allSettled(requests)
        const byId = new Map()
        results.forEach((r) => {
          if (r.status !== 'fulfilled') return
          const list = Array.isArray(r.value.data) ? r.value.data : []
          list.forEach((p) => {
            if (p && p.id && !byId.has(p.id)) byId.set(p.id, p)
          })
        })
        this.products = Array.from(byId.values())
      } catch (e) {
        this.products = []
      } finally {
        this.loading = false
      }
    },
    openProduct (p) {
      if (checkProductoAgotado(p)) return
      const code = this.$clientCode()
      this.$emit('navigate')
      this.$router.push({ name: 'Producto', params: { client: code, id: p.id } })
    },
    onAdd (p) {
      if (this.tiendaCerrada || checkProductoAgotado(p)) return
      // Productos simples: agregar directo; combos/configurables: ir al detalle
      if (p.tipo === 1) {
        this.addItem({
          id: p.id,
          nombre: p.nombre,
          tipo: p.tipo,
          cant: 1,
          totalPrice: p.precio,
          PrecioUnitario: p.precio,
          items: [],
          esCombinadoCombo: false,
          esSeleccion: false,
          detalle: p.detalle || { srcImg: null },
          Descuentos: p.Descuentos || [],
          GrupoDescuento: p.GrupoDescuento || null
        })
      } else {
        this.openProduct(p)
      }
    }
  }
}
</script>
<style scoped>
.cart-suggestions {
  margin-top: 8px;
  padding-top: 4px;
}
.suggestions-title {
  margin: 0 0 12px;
  font-size: 1.05rem;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.87);
}
.suggestions-scroll {
  display: flex;
  gap: 12px;
  overflow-x: auto;
  padding: 2px 2px 10px;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
}
.suggestion-card {
  flex: 0 0 148px;
  width: 148px;
  background: #fff;
  border: 1px solid #ececec;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}
.suggestion-img-wrap {
  position: relative;
  cursor: pointer;
}
.suggestion-img {
  width: 100%;
  height: 110px;
  background: #f3f3f3;
}
.suggestion-img--empty {
  display: flex;
  align-items: center;
  justify-content: center;
}
.suggestion-add {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.18);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.75);
}
.suggestion-add:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.suggestion-body {
  padding: 10px 10px 12px;
  cursor: pointer;
}
.suggestion-name {
  font-size: 0.9rem;
  font-weight: 700;
  line-height: 1.25;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 2.5em;
}
.suggestion-desc {
  margin-top: 4px;
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.5);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.suggestion-price {
  margin-top: 8px;
  font-size: 0.95rem;
  font-weight: 700;
}
.suggestion-price-old {
  margin-left: 4px;
  color: rgba(0, 0, 0, 0.45);
  font-weight: 500;
  font-size: 0.8rem;
}
</style>
